import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { Undo2, Check, X } from 'lucide-react';
import { ps, psFill } from '../lib/pdfSel';

// print area: tap the corners on the map (map clicks are routed via giss-area-click while drawing)
export default function AreaDraw({ mapRef }) {
  const [req, setReq] = useState(null), [pts, setPts] = useState([]), ref = useRef([]), x = ps();
  useEffect(() => {
    const on = (e) => { setReq(e.detail); ref.current = []; setPts([]); };
    window.addEventListener('giss-pdf-area', on);
    return () => window.removeEventListener('giss-pdf-area', on);
  }, []);
  useEffect(() => {
    if (!req) return undefined;
    window.__gissAreaDraw = true; document.body.classList.add('area-drawing');
    const on = (e) => { ref.current = [...ref.current, e.detail]; setPts(ref.current); };
    window.addEventListener('giss-area-click', on);
    return () => { window.__gissAreaDraw = false; document.body.classList.remove('area-drawing'); window.removeEventListener('giss-area-click', on); mapRef.current?.areaShape?.(null); }; // eslint-disable-line react-hooks/exhaustive-deps
  }, [req, mapRef]);
  useEffect(() => { if (req) mapRef.current?.areaShape?.(pts); }, [pts, req, mapRef]);
  if (!req) return null;
  const end = (v) => { req.resolve(v); setReq(null); };
  const undo = () => { ref.current = ref.current.slice(0, -1); setPts(ref.current); };
  const done = () => (pts.length < 3 ? toast.error(x.min3) : end(pts));
  return (
    <div className="area-draw" data-testid="area-draw-bar">
      <b>{x.drawHint}</b>
      <span data-testid="area-draw-count">{psFill(x.drawPts, { n: pts.length })}</span>
      <button className="btn btn-outline btn-sm" data-testid="area-draw-undo" disabled={!pts.length} onClick={undo}><Undo2 size={14} /> {x.undo}</button>
      <button className="btn btn-outline btn-sm" data-testid="area-draw-cancel" onClick={() => end(null)}><X size={14} /> {x.cancel}</button>
      <button className="btn btn-green btn-sm" data-testid="area-draw-done" onClick={done}><Check size={14} /> {x.finish}</button>
    </div>
  );
}
